<div class="panel-flex">
  <content-panel>
    <panel-header heading="Support" />
    <panel-body>
    @if(isEcAdmin) {
     <app-energy-credit-support class="list-row-container"/>
    }
    @if(isQBuiltAdmin){
      <app-qbuilt-support class="list-row-container"/>
    }
    </panel-body>
  </content-panel>
</div>
